<div class="modal-header">
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <p class="large text-center mb-5">{{prompt}}</p>
    <div class="d-flex justify-content-center align-items-center">
        <button type="button" class="btn btn-outline-primary me-2" (click)="dismissModal()">{{cancelBtnText}}</button>
        <button type="submit" class="btn btn-primary me-2" (click)="confirmModal(false)">{{noBtnText}}</button>
        <button type="submit" class="btn btn-primary" focus-me (click)="confirmModal(true)">{{yesBtnText}}</button>
    </div>
</div>